import { PDFDocument } from 'pdf-lib';
import { Arbitro } from 'src/app/arbitros/arbitros.model';
import { convertColegiacionesToLabels, convertIdiomasToLabels, convertNacionalidadesToLabels, convertSectoresToLabels, convertsistemasJuridicosToLabels } from './utils';
import { Select2Data } from 'ng-select2-component';
import { ArbitrosService } from 'src/app/arbitros/arbitros.service';
import { forkJoin } from 'rxjs';
import { getCurrentLanguage } from './utils';

// Descarga de PDF
// Descargar PDF
async function fillAndDownloadPDF(arbitro: Arbitro, arbitrosService: ArbitrosService) {

  forkJoin({
    resNacionalidades: arbitrosService.getNacionalidades(),
    resColegiaciones: arbitrosService.getColegiaciones(),
    resProfesiones: arbitrosService.getProfesiones(),
    resIdiomas: arbitrosService.getIdiomas(),
    resSectores: arbitrosService.getSectores(),
    resSistemasJuridicos: arbitrosService.getSistemasJuridicos()
  }).subscribe({
    next: async ({ resNacionalidades, resColegiaciones, resProfesiones, resIdiomas, resSectores, resSistemasJuridicos }) => {

      const currentLanguage: string = getCurrentLanguage();
      
      //console.log("Nacionalidades", resNacionalidades)
      // Convertir los resultados a Select2Data
      const nacionalidades: Select2Data = resNacionalidades.map(item => ({
        value: item.codigo_alfa2,
        label: item[currentLanguage]
      }));

      const colegiaciones: Select2Data = resColegiaciones.map(item => ({
        value: item.codigo_alfa2,
        label: item[currentLanguage]
      }));

      const profesiones: Select2Data = resProfesiones.map(item => ({
        value: item.nombre,
        label: item[currentLanguage]
      }));

      const idiomas: Select2Data = resIdiomas.map(item => ({
        value: item.nombre,
        label: item[currentLanguage]
      }));

      const sectores: Select2Data = resSectores.map(item => ({
        value: item.nombre,
        label: item[currentLanguage]
      }));

      const sistemasJuridicos: Select2Data = resSistemasJuridicos.map(item => ({
        value: item.nombre,
        label: item[currentLanguage]
      }));


      //console.log("arbitro", arbitro)
      // Cargar el PDF existente
      const existingPdfBytes = await fetch('assets/pdfs/CV_esp.pdf').then(res => res.arrayBuffer());

      // Cargar el documento PDF
      const pdfDoc = await PDFDocument.load(existingPdfBytes);

      // Rellenar los campos del formulario en el PDF
      const form = pdfDoc.getForm();
      form.getTextField('nombre').setText(arbitro.nombre ?? '');
      form.getTextField('apellidos').setText(arbitro.apellidos ?? '');

      if (arbitro.fecha_nacimiento) {
        const fecha = new Date(arbitro.fecha_nacimiento); // Convierte la fecha de la BD a un objeto Date
        const dia = ("0" + fecha.getDate()).slice(-2); // Asegura dos dígitos para el día
        const mes = ("0" + (fecha.getMonth() + 1)).slice(-2); // Asegura dos dígitos para el mes
        const año = fecha.getFullYear(); // Año completo
        const formattedDate = `${dia}/${mes}/${año}`; // Formato 'DD/MM/YYYY'
        form.getTextField('fecha_nacimiento').setText(formattedDate);
      } else {
        form.getTextField('fecha_nacimiento').setText('');
      }


      form.getTextField('genero').setText(arbitro.genero ?? '');
      form.getTextField('titulo').setText(arbitro.titulo ?? '');
      form.getTextField('institucion').setText(arbitro.institucion ?? '');
      form.getTextField('direccion').setText(arbitro.direccion ?? '');
      form.getTextField('telefono').setText(arbitro.telefono ?? '');
      form.getTextField('movil').setText(arbitro.movil ?? '');
      form.getTextField('email').setText(arbitro.email ?? '');
      form.getTextField('cargo').setText(arbitro.cargo ?? '');

      const nacionalidadesLabels = convertNacionalidadesToLabels(arbitro.nacionalidades ?? [], nacionalidades);
      form.getTextField('nacionalidades').setText(nacionalidadesLabels ?? '');

      const profesionesLabels = convertNacionalidadesToLabels(arbitro.profesiones ?? [], profesiones);
      form.getTextField('profesiones').setText(profesionesLabels ?? '');

      form.getTextField('profesiones_otras').setText(arbitro.profesion_otras ?? '');
      form.getTextField('titulos_academicos').setText(arbitro.titulos_academicos ?? '');
      form.getTextField('experiencia_profesional').setText(arbitro.experiencia_profesional ?? '');

      const colegiacionesLabels = convertColegiacionesToLabels(arbitro.colegiaciones ?? [], colegiaciones);
      form.getTextField('colegiaciones').setText(colegiacionesLabels ?? '');

      const idiomasLabels = convertIdiomasToLabels(arbitro.idiomas ?? [], idiomas);
      if (arbitro.idiomas_otros) {
        let idiomasMerge = idiomasLabels + "\n" + "Otros idiomas: " + arbitro.idiomas_otros;
        form.getTextField('idiomas').setText(idiomasMerge ?? '');
      } else {
        form.getTextField('idiomas').setText(idiomasLabels ?? '');
      }

      const sectoresLabels = convertSectoresToLabels(arbitro.sectores ?? [], sectores);
      if (arbitro.sectores_otros) {
        let sectoresMerge = sectoresLabels + "\n" + "Otros sectores: " + arbitro.sectores_otros;
        form.getTextField('sectores').setText(sectoresMerge ?? '');
      } else {
        form.getTextField('sectores').setText(sectoresLabels ?? '');
      }

      if (arbitro.comunicaciones_comerciales)
        form.getCheckBox('comunicaciones_comerciales_si').check();
      else
        form.getCheckBox('comunicaciones_comerciales_no').check();

      if (arbitro.experiencia_cumplimentada)
        form.getCheckBox('experiencia_cumplimentada').check();

      const sistemasJuridicosLabels = convertsistemasJuridicosToLabels(arbitro.sistemasJuridicos ?? [], sistemasJuridicos);
      if (arbitro.sistema_juridico_otros) {
        let sistemasJuridicosMerge = sectoresLabels + "\n" + "Otros sistemas Jurídicos: " + arbitro.sistema_juridico_otros;
        form.getTextField('sistemasJuridicos').setText(sistemasJuridicosMerge ?? '');
      } else {
        form.getTextField('sistemasJuridicos').setText(sistemasJuridicosLabels ?? '');
      }

      // Experiencia y totales

      form.getTextField('exp_internacional_ciam_presidente').setText(arbitro.exp_internacional_ciam_presidente?.toString() ?? '');
      form.getTextField('exp_internacional_otra_presidente').setText(arbitro.exp_internacional_otra_presidente?.toString() ?? '');
      form.getTextField('exp_internacional_adhoc_presidente').setText(arbitro.exp_internacional_adhoc_presidente?.toString() ?? '');
      form.getTextField('exp_nacional_institucional_presidente').setText(arbitro.exp_nacional_institucional_presidente?.toString() ?? '');
      form.getTextField('exp_nacional_adhoc_presidente').setText(arbitro.exp_nacional_adhoc_presidente?.toString() ?? '');
      form.getTextField('exp_internacional_ciam_arbitro_unico').setText(arbitro.exp_internacional_ciam_arbitro_unico?.toString() ?? '');
      form.getTextField('exp_internacional_otra_arbitro_unico').setText(arbitro.exp_internacional_otra_arbitro_unico?.toString() ?? '');
      form.getTextField('exp_internacional_adhoc_arbitro_unico').setText(arbitro.exp_internacional_adhoc_arbitro_unico?.toString() ?? '');
      form.getTextField('exp_nacional_institucional_arbitro_unico').setText(arbitro.exp_nacional_institucional_arbitro_unico?.toString() ?? '');
      form.getTextField('exp_nacional_adhoc_arbitro_unico').setText(arbitro.exp_nacional_adhoc_arbitro_unico?.toString() ?? '');
      form.getTextField('exp_internacional_ciam_coarbitro').setText(arbitro.exp_internacional_ciam_coarbitro?.toString() ?? '');
      form.getTextField('exp_internacional_otra_coarbitro').setText(arbitro.exp_internacional_otra_coarbitro?.toString() ?? '');
      form.getTextField('exp_internacional_adhoc_coarbitro').setText(arbitro.exp_internacional_adhoc_coarbitro?.toString() ?? '');
      form.getTextField('exp_nacional_institucional_coarbitro').setText(arbitro.exp_nacional_institucional_coarbitro?.toString() ?? '');
      form.getTextField('exp_nacional_adhoc_coarbitro').setText(arbitro.exp_nacional_adhoc_coarbitro?.toString() ?? '');
      form.getTextField('exp_internacional_ciam_letrado').setText(arbitro.exp_internacional_ciam_letrado?.toString() ?? '');
      form.getTextField('exp_internacional_otra_letrado').setText(arbitro.exp_internacional_otra_letrado?.toString() ?? '');
      form.getTextField('exp_internacional_adhoc_letrado').setText(arbitro.exp_internacional_adhoc_letrado?.toString() ?? '');
      form.getTextField('exp_nacional_institucional_letrado').setText(arbitro.exp_nacional_institucional_letrado?.toString() ?? '');
      form.getTextField('exp_nacional_adhoc_letrado').setText(arbitro.exp_nacional_adhoc_letrado?.toString() ?? '');
      form.getTextField('exp_internacional_ciam_secretario').setText(arbitro.exp_internacional_ciam_secretario?.toString() ?? '');
      form.getTextField('exp_internacional_otra_secretario').setText(arbitro.exp_internacional_otra_secretario?.toString() ?? '');
      form.getTextField('exp_internacional_adhoc_secretario').setText(arbitro.exp_internacional_adhoc_secretario?.toString() ?? '');
      form.getTextField('exp_nacional_institucional_secretario').setText(arbitro.exp_nacional_institucional_secretario?.toString() ?? '');
      form.getTextField('exp_nacional_adhoc_secretario').setText(arbitro.exp_nacional_adhoc_secretario?.toString() ?? '');
      form.getTextField('exp_internacional_ciam_arbitro_emergencia').setText(arbitro.exp_internacional_ciam_arbitro_emergencia?.toString() ?? '');
      form.getTextField('exp_internacional_otra_arbitro_emergencia').setText(arbitro.exp_internacional_otra_arbitro_emergencia?.toString() ?? '');
      form.getTextField('exp_internacional_adhoc_arbitro_emergencia').setText(arbitro.exp_internacional_adhoc_arbitro_emergencia?.toString() ?? '');
      form.getTextField('exp_nacional_institucional_arbitro_emergencia').setText(arbitro.exp_nacional_institucional_arbitro_emergencia?.toString() ?? '');
      form.getTextField('exp_nacional_adhoc_arbitro_emergencia').setText(arbitro.exp_nacional_adhoc_arbitro_emergencia?.toString() ?? '');

      // Totales de las filas
      const totalFilaCIAM = Number(arbitro.exp_internacional_ciam_presidente ?? 0) +
        Number(arbitro.exp_internacional_ciam_arbitro_unico ?? 0) +
        Number(arbitro.exp_internacional_ciam_coarbitro ?? 0) +
        Number(arbitro.exp_internacional_ciam_letrado ?? 0) +
        Number(arbitro.exp_internacional_ciam_secretario ?? 0) +
        Number(arbitro.exp_internacional_ciam_arbitro_emergencia ?? 0);
      form.getTextField('totalFilaCIAM').setText(totalFilaCIAM.toString());

      const totalFilaOtraInstitucion = Number(arbitro.exp_internacional_otra_presidente ?? 0) +
        Number(arbitro.exp_internacional_otra_arbitro_unico ?? 0) +
        Number(arbitro.exp_internacional_otra_coarbitro ?? 0) +
        Number(arbitro.exp_internacional_otra_letrado ?? 0) +
        Number(arbitro.exp_internacional_otra_secretario ?? 0) +
        Number(arbitro.exp_internacional_otra_arbitro_emergencia ?? 0);
      form.getTextField('totalFilaOtraInstitucion').setText(totalFilaOtraInstitucion.toString());

      const totalFilaAdHocInternacional = Number(arbitro.exp_internacional_adhoc_presidente ?? 0) +
        Number(arbitro.exp_internacional_adhoc_arbitro_unico ?? 0) +
        Number(arbitro.exp_internacional_adhoc_coarbitro ?? 0) +
        Number(arbitro.exp_internacional_adhoc_letrado ?? 0) +
        Number(arbitro.exp_internacional_adhoc_secretario ?? 0) +
        Number(arbitro.exp_internacional_adhoc_arbitro_emergencia ?? 0);
      form.getTextField('totalFilaAdHocInternacional').setText(totalFilaAdHocInternacional.toString());


      const totalFilaInstitucional = Number(arbitro.exp_nacional_institucional_presidente ?? 0) +
        Number(arbitro.exp_nacional_institucional_arbitro_unico ?? 0) +
        Number(arbitro.exp_nacional_institucional_coarbitro ?? 0) +
        Number(arbitro.exp_nacional_institucional_letrado ?? 0) +
        Number(arbitro.exp_nacional_institucional_secretario ?? 0) +
        Number(arbitro.exp_nacional_institucional_arbitro_emergencia ?? 0);
      form.getTextField('totalFilaInstitucional').setText(totalFilaInstitucional.toString());

      const totalFilaAdHocNacional = Number(arbitro.exp_nacional_adhoc_presidente ?? 0) +
        Number(arbitro.exp_nacional_adhoc_arbitro_unico ?? 0) +
        Number(arbitro.exp_nacional_adhoc_coarbitro ?? 0) +
        Number(arbitro.exp_nacional_adhoc_letrado ?? 0) +
        Number(arbitro.exp_nacional_adhoc_secretario ?? 0) +
        Number(arbitro.exp_nacional_adhoc_arbitro_emergencia ?? 0);
      form.getTextField('totalFilaAdHocNacional').setText(totalFilaAdHocNacional.toString());

      const totalColumnaPresidente = Number(arbitro.exp_internacional_ciam_presidente ?? 0) +
        Number(arbitro.exp_internacional_otra_presidente ?? 0) +
        Number(arbitro.exp_internacional_adhoc_presidente ?? 0) +
        Number(arbitro.exp_nacional_institucional_presidente ?? 0) +
        Number(arbitro.exp_nacional_adhoc_presidente ?? 0);
      form.getTextField('totalColumnaPresidente').setText(totalColumnaPresidente.toString());

      const totalColumnaArbitroUnico = Number(arbitro.exp_internacional_ciam_arbitro_unico ?? 0) +
        Number(arbitro.exp_internacional_otra_arbitro_unico ?? 0) +
        Number(arbitro.exp_internacional_adhoc_arbitro_unico ?? 0) +
        Number(arbitro.exp_nacional_institucional_arbitro_unico ?? 0) +
        Number(arbitro.exp_nacional_adhoc_arbitro_unico ?? 0);
      form.getTextField('totalColumnaArbitroUnico').setText(totalColumnaArbitroUnico.toString());

      const totalColumnaCoarbitro = Number(arbitro.exp_internacional_ciam_coarbitro ?? 0) +
        Number(arbitro.exp_internacional_otra_coarbitro ?? 0) +
        Number(arbitro.exp_internacional_adhoc_coarbitro ?? 0) +
        Number(arbitro.exp_nacional_institucional_coarbitro ?? 0) +
        Number(arbitro.exp_nacional_adhoc_coarbitro ?? 0);
      form.getTextField('totalColumnaCoarbitro').setText(totalColumnaCoarbitro.toString());

      const totalColumnaLetrado = Number(arbitro.exp_internacional_ciam_letrado ?? 0) +
        Number(arbitro.exp_internacional_otra_letrado ?? 0) +
        Number(arbitro.exp_internacional_adhoc_letrado ?? 0) +
        Number(arbitro.exp_nacional_institucional_letrado ?? 0) +
        Number(arbitro.exp_nacional_adhoc_letrado ?? 0);
      form.getTextField('totalColumnaLetrado').setText(totalColumnaLetrado.toString());

      const totalColumnaSecretario = Number(arbitro.exp_internacional_ciam_secretario ?? 0) +
        Number(arbitro.exp_internacional_otra_secretario ?? 0) +
        Number(arbitro.exp_internacional_adhoc_secretario ?? 0) +
        Number(arbitro.exp_nacional_institucional_secretario ?? 0) +
        Number(arbitro.exp_nacional_adhoc_secretario ?? 0);
      form.getTextField('totalColumnaSecretario').setText(totalColumnaSecretario.toString());

      const totalColumnaArbitroEmergencia = Number(arbitro.exp_internacional_ciam_arbitro_emergencia ?? 0) +
        Number(arbitro.exp_internacional_otra_arbitro_emergencia ?? 0) +
        Number(arbitro.exp_internacional_adhoc_arbitro_emergencia ?? 0) +
        Number(arbitro.exp_nacional_institucional_arbitro_emergencia ?? 0) +
        Number(arbitro.exp_nacional_adhoc_arbitro_emergencia ?? 0);
      form.getTextField('totalColumnaArbitroEmergencia').setText(totalColumnaArbitroEmergencia.toString());





      // Serializar el PDFDocument a bytes
      const pdfBytes = await pdfDoc.save();

      // Crear un Blob a partir de los bytes del PDF
      const blob = new Blob([pdfBytes], { type: 'application/pdf' });

      // Crear un enlace para descargar el PDF y hacer clic en él
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = arbitro.nombre + '_' + arbitro.apellidos + '.pdf';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    error: (err) => {
      console.error('Error al obtener datos para el PDF:', err);
    }
  });


}

export { fillAndDownloadPDF }